import { styled } from 'styled-components';
import { theme } from 'styles/theme';

export const DisclaimerContentWrapper = styled.p`
  color: ${theme.colors.textDisclaimer};
  ${theme.typography.body6};
`;

export const DisclaimerItalicsContentWrapper = styled.p`
  color: ${theme.colors.textDisclaimer};
  ${theme.typography.body4};
  font-style: italic;
`;
